import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { isToday as importedIsToday, isYesterday as importedIsYesterday } from '@/helpers/date-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeAgo',
  props: {
    date: null
  },
  setup(__props: any) {

const props = __props as {
	date: string;
};



const _date = computed(() => new Date(props.date));
const isToday = computed(() => importedIsToday(_date.value));
const isYesterday = computed(() => importedIsYesterday(_date.value));

return { __sfc: true,props, _date, isToday, isYesterday }
}

})